import messages from "@smartmixin/i18n/dist/translations/nb.json";

export default messages;
